<template>
  <v-dialog v-model="isOpen" scrollable max-width="1000px">
    <v-card>
      <v-card-title>
        <v-layout row wrap>
          <v-flex sm4 pr-1>
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm4 pr-1>
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.toDate"
                label="To Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.toDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm4 pr-1>
            <v-text-field
              name="issueNo"
              label="Issue No"
              type="text"
              v-model="queryParams.issueNo"
            ></v-text-field>
          </v-flex>
          <v-flex sm4 pr-1>
            <v-text-field
              name="qcNo"
              label="QC No"
              type="text"
              v-model="queryParams.qcNo"
            ></v-text-field>
          </v-flex>
          <v-flex sm4>
            <v-btn outline color="primary" @click="onSearch">
              Search
              <v-icon right>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="qcList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.warehouseName }}</td>
              <td>
                {{ props.item.issueDateInMilliSeconds | formatMsDate }}
              </td>
              <td @click="addQC(props.item)">
                <a>{{ props.item.issueNo }}</a>
              </td>
              <td>{{ props.item.qcNo }}</td>
              <td>{{ props.item.purchaseOrderNo }}</td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.reference }}</td>
              <td>
                {{ props.item.updatedDateInMilliSeconds | formatMsDateTime }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { qcService } from "../../services/qc-service";
import { commonService } from "../../services/common-service";

export default {
  name: "QCListDialog",
  props: {
    showDialog: Boolean,
    params: Object,
  },
  computed: {
    isOpen: {
      get() {
        return this.showDialog;
      },
      set() {
        this.dialogClose({});
      },
    },
  },
  data: () => ({
    showListLoading: false,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      qcNo: "",
    },
    headers: [
      { text: "Warehouse", value: "warehouseName" },
      { text: "Issue Date", align: "left", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "QC No", value: "qcNo" },
      { text: "PO No", value: "purchaseOrder.issueNo" },
      { text: "Status", value: "status" },
      { text: "Reference", value: "reference" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    rowsPerPageItems: [25, 50, 100],
    totalRows: 0,
    qcList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getQCList();
      },
      deep: true,
    },
    isOpen: {
      handler() {
        if (this.isOpen) {
          this.queryParams.fromDate = commonService.formatDate(
            new Date(),
            "YYYY-MM-DD"
          );
          this.queryParams.toDate = commonService.formatDate(
            new Date(),
            "YYYY-MM-DD"
          );
          this.queryParams.issueNo = "";
          this.queryParams.qcNo = "";

          this.queryParams = {
            ...this.queryParams,
            ...this.params,
          };

          this.getQCList();
        }
      },
    },
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getQCList();
    },
    getQCList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      qcService
        .getQCList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.qcList = res.data.qcList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    addQC(qc) {
      this.dialogClose(qc);
    },
    dialogClose(qc) {
      this.$emit("close", qc);
    },
  },
};
</script>
